import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import IOSInstall from "../../integrate/_snippets/install-ios.mdx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2 {...{
      "id": "step-one-add-posthog-to-your-app"
    }}>{`Step one: Add PostHog to your app`}</h2>
    <p>{`Using it requires PostHog's iOS SDK version >= 3.31.0, but it's recommended to always use `}<a parentName="p" {...{
        "href": "/docs/sdk-doctor"
      }}>{`the latest version`}</a>{`.`}</p>

    <IOSInstall mdxType="IOSInstall" />
    <h2 {...{
      "id": "step-two-enable-surveys-in-your-configuration"
    }}>{`Step two: Enable surveys in your configuration`}</h2>
    <p>{`To enable surveys in your iOS app, enable surveys in your PostHog configuration:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`let POSTHOG_API_KEY = "<ph_project_api_key>"
// usually 'https://us.i.posthog.com' or 'https://eu.i.posthog.com'
let POSTHOG_HOST = "<ph_client_api_host>"
let config = PostHogConfig(apiKey: POSTHOG_API_KEY, host: POSTHOG_HOST) // TIP: host is optional if you use https://us.i.posthog.com

// Surveys require iOS 15.0 or later
if #available(iOS 15.0, *) {
    config.surveys = true
}

PostHogSDK.shared.setup(config)
`}</code></pre>
    <h2 {...{
      "id": "supported-features"
    }}>{`Supported Features`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Feature`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Support`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Questions`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`All question types`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`✅`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Multi-question surveys`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`✅`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Confirmation message`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`✅`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Feedback button presentation`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`❌`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Conditional questions`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`✅`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Customization / Appearance`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Set colors in PostHog dashboard`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`✅`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Shuffle questions`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`❌`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`PostHog branding`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`❌`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Delay popup after screen view`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`❌`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Position config`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`❌ (always bottom sheet)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`HTML content`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`❌`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Display conditions`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Feature flag & property targeting`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`✅`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Screen targeting`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`❌`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Device type targeting`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`✅`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Survey wait period`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`❌`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Event triggers`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`✅`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Action triggers`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`❌`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Partial responses`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`❌`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "limitations"
    }}>{`Limitations`}</h2>
    <ul>
      <li parentName="ul">{`Surveys are only available on iOS`}</li>
      <li parentName="ul">{`Surveys require iOS 15.0 or later`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      